import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "clients-page" };
const _hoisted_2 = { class: "clients-inner" };
const _hoisted_3 = { class: "page-header" };
const _hoisted_4 = { class: "top-actions" };
const _hoisted_5 = { class: "list-toolbar" };
const _hoisted_6 = {
    class: "filters",
    role: "tablist",
    "aria-label": "User role filters"
};
const _hoisted_7 = { class: "search-wrap" };
const _hoisted_8 = {
    key: 0,
    class: "loading"
};
const _hoisted_9 = {
    key: 1,
    class: "cards",
    role: "list"
};
const _hoisted_10 = { class: "avatar-wrap" };
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "info" };
const _hoisted_13 = { class: "name" };
const _hoisted_14 = { class: "stats" };
const _hoisted_15 = { class: "stat" };
const _hoisted_16 = { class: "stat-value" };
const _hoisted_17 = { class: "stat" };
const _hoisted_18 = { class: "stat-value" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["aria-hidden"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    key: 0,
    class: "empty"
};
const _hoisted_24 = {
    key: 2,
    class: "pagination-row"
};
const _hoisted_25 = { class: "pagination-left" };
const _hoisted_26 = {
    class: "pagination-right",
    role: "navigation",
    "aria-label": "Pagination"
};
const _hoisted_27 = ["disabled"];
const _hoisted_28 = ["onClick", "disabled"];
const _hoisted_29 = ["disabled"];
const _hoisted_30 = { class: "modal-card" };
const _hoisted_31 = { class: "modal-body" };
const _hoisted_32 = { class: "modal-actions" };
const _hoisted_33 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AddUserPopup = _resolveComponent("AddUserPopup");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", _hoisted_3, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                        _createElementVNode("p", { class: "eyebrow" }, "CLIENT DIRECTORY"),
                        _createElementVNode("h1", null, "Clients")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            class: "export-btn",
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.exportUsers && _ctx.exportUsers(...args)))
                        }, "Export User Data"),
                        _createElementVNode("button", {
                            class: "add-user",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.onAddUser && _ctx.onAddUser(...args)))
                        }, "Add User")
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["filter-btn", { active: _ctx.roleFilter === 'All' }]),
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.setFilter('All')))
                        }, "All", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["filter-btn", { active: _ctx.roleFilter === 'admin' }]),
                            onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.setFilter('admin')))
                        }, "Admin", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["filter-btn", { active: _ctx.roleFilter === 'client' }]),
                            onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.setFilter('client')))
                        }, "Client", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["filter-btn", { active: _ctx.roleFilter === 'staff' }]),
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.setFilter('staff')))
                        }, "Staff", 2)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.searchQuery) = $event)),
                            class: "search-input",
                            type: "search",
                            placeholder: "Search users",
                            "aria-label": "Search users"
                        }, null, 512), [
                            [_vModelText, _ctx.searchQuery]
                        ])
                    ])
                ]),
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Loading users…"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedUsers, (u, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: String(u.id ?? u.email ?? idx),
                                class: "card",
                                role: "listitem"
                            }, [
                                _cache[20] || (_cache[20] = _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "select"
                                }, null, -1)),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("img", {
                                        src: u.photoURL || _ctx.placeholder,
                                        alt: "avatar",
                                        class: "avatar"
                                    }, null, 8, _hoisted_11)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(u.displayName || 'Unknown'), 1),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["role", u.role])
                                    }, _toDisplayString(u.role || 'client'), 3)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, _toDisplayString(u.orders ?? 0), 1),
                                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "stat-label" }, "Orders", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatMoney(u.monthTotal ?? 0)), 1),
                                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "stat-label" }, "Month Total", -1))
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    class: "actions",
                                    onClick: ($event) => (_ctx.toggleMenu(u.id ?? idx)),
                                    "aria-label": "Actions"
                                }, "⋮", 8, _hoisted_19),
                                _withDirectives(_createElementVNode("div", {
                                    class: "menu",
                                    role: "menu",
                                    "aria-hidden": _ctx.openMenu !== String(u.id ?? idx)
                                }, [
                                    _createElementVNode("button", {
                                        onClick: ($event) => (_ctx.viewProfile(u))
                                    }, "View User Profile", 8, _hoisted_21),
                                    _createElementVNode("button", {
                                        onClick: ($event) => (_ctx.passwordResetRequest(u))
                                    }, "Password Reset Request", 8, _hoisted_22)
                                ], 8, _hoisted_20), [
                                    [_vShow, _ctx.openMenu === String(u.id ?? idx)]
                                ])
                            ]));
                        }), 128)),
                        (_ctx.filteredUsers.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, "No users found."))
                            : _createCommentVNode("", true)
                    ])),
                (_ctx.total > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, "Showing " + _toDisplayString(_ctx.showStart) + " - " + _toDisplayString(_ctx.showEnd) + " of " + _toDisplayString(_ctx.total), 1),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("button", {
                                class: "page-btn",
                                disabled: _ctx.page === 1,
                                onClick: _cache[7] || (_cache[7] =
                                    //@ts-ignore
                                    (...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                            }, "‹", 8, _hoisted_27),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageRange, (p) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: String(p),
                                    class: _normalizeClass(["page-number", { active: p === _ctx.page, dots: p === '...' }]),
                                    onClick: ($event) => (typeof p === 'number' && _ctx.goToPage(p)),
                                    disabled: p === '...'
                                }, _toDisplayString(p), 11, _hoisted_28));
                            }), 128)),
                            _createElementVNode("button", {
                                class: "page-btn",
                                disabled: _ctx.page === _ctx.totalPages,
                                onClick: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                            }, "›", 8, _hoisted_29)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.showAddUser)
            ? (_openBlock(), _createBlock(_component_AddUserPopup, {
                key: 0,
                "initial-role": _ctx.roleFilter,
                "initial-user": _ctx.addUserInitial,
                onClose: _cache[9] || (_cache[9] = ($event) => (_ctx.showAddUser = false)),
                onCreated: _ctx.onCreated,
                onUpdate: _ctx.handleUpdate
            }, null, 8, ["initial-role", "initial-user", "onCreated", "onUpdate"]))
            : _createCommentVNode("", true),
        (_ctx.showEditModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "modal-backdrop",
                onClick: _cache[16] || (_cache[16] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.closeEdit && _ctx.closeEdit(...args)), ["self"]))
            }, [
                _createElementVNode("div", _hoisted_30, [
                    _cache[27] || (_cache[27] = _createElementVNode("h3", null, "Edit User", -1)),
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("label", null, [
                            _cache[21] || (_cache[21] = _createTextVNode(" Name ", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.editForm.displayName) = $event)),
                                type: "text"
                            }, null, 512), [
                                [_vModelText, _ctx.editForm.displayName]
                            ])
                        ]),
                        _createElementVNode("label", null, [
                            _cache[22] || (_cache[22] = _createTextVNode(" Email (cannot change via client) ", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.editForm.email) = $event)),
                                type: "email",
                                disabled: ""
                            }, null, 512), [
                                [_vModelText, _ctx.editForm.email]
                            ])
                        ]),
                        _createElementVNode("label", null, [
                            _cache[24] || (_cache[24] = _createTextVNode(" Role ", -1)),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.editForm.role) = $event))
                            }, _cache[23] || (_cache[23] = [
                                _createElementVNode("option", { value: "admin" }, "admin", -1),
                                _createElementVNode("option", { value: "staff" }, "staff", -1),
                                _createElementVNode("option", { value: "client" }, "client", -1)
                            ]), 512), [
                                [_vModelSelect, _ctx.editForm.role]
                            ])
                        ]),
                        _createElementVNode("label", null, [
                            _cache[25] || (_cache[25] = _createTextVNode(" Company ", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.editForm.companyName) = $event)),
                                type: "text"
                            }, null, 512), [
                                [_vModelText, _ctx.editForm.companyName]
                            ])
                        ]),
                        _cache[26] || (_cache[26] = _createElementVNode("p", { class: "note" }, "To change Auth email or password use an admin function or the Auth console.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("button", {
                            onClick: _cache[14] || (_cache[14] =
                                //@ts-ignore
                                (...args) => (_ctx.saveEdit && _ctx.saveEdit(...args))),
                            disabled: _ctx.savingEdit
                        }, "Save", 8, _hoisted_33),
                        _createElementVNode("button", {
                            onClick: _cache[15] || (_cache[15] =
                                //@ts-ignore
                                (...args) => (_ctx.closeEdit && _ctx.closeEdit(...args)))
                        }, "Cancel")
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
